/* eslint-disable */
import Navigation from '../components/Navigation';
import Cookies from '../components/Cookies';

export default {
    navigationInit() {
        const navigation = new Navigation;
        navigation.init();
    },

    smoothScroll() {
        $('a.smooth').bind('click', function(e) {
            e.preventDefault();

            const target = $(this).attr('href');

            $('html, body').stop().animate({
                scrollTop: $(target).offset().top - 70,
            }, 600);

            return false;
        });
    },

    languageSwitcher() {
        let currentLang = $('.language-switcher .current-lang');
        let currentLangAttr = currentLang.find('a').attr('lang');
        let logoLink = $('.logo__brand');

        currentLang.on('click', function(e) {
            e.preventDefault();

            $(this).closest('.language-switcher').toggleClass('is-visible');
        });

        if (currentLangAttr.substr(0, currentLangAttr.indexOf('-')) !== 'pl') {
            logoLink.attr('href', window.location.origin + '/' + currentLangAttr.substr(0, currentLangAttr.indexOf('-')))
        }
        
        if (currentLangAttr === 'uk') {
            logoLink.attr('href', window.location.origin + '/uk')
        }
    },

    init() {
        this.navigationInit(); 
        this.smoothScroll();

        this.languageSwitcher();
        
        //Cookie init
        Cookies();
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js